import { HorizonGeospatialThreatZoneFeature } from '../features/horizon/horizon-geospatial-threat-zone.feature';
import { StandardLayerRenderer } from './standard-layer.renderer';

export class HorizonGeospatialThreatZoneLayerRenderer extends StandardLayerRenderer {
  protected Feature = HorizonGeospatialThreatZoneFeature;
}
